import { Component, effect, inject, input, OnDestroy, OnInit, output, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import {
  CorporateReportTypes,
  QuarterRangeSelectorValue,
  QuarterSelectorType,
  QuarterSelectorValue,
  InputProps,
} from '@miq/shared-models';
// L2-S5: `getMarketQtd` is now on @miq/platform's SharedApiService (SharedService delegates to
// it), so this component no longer injects the 868-line god service — that single HTTP GET was
// dragging 79 host files into every bundle that renders a filters bar.
import { SharedApiService } from '@miq/platform';
import { FilterBarLabelComponent } from '../../filter-bar-label/filter-bar-label.component';
import { QuarterSelectorComponent } from '../../quarter-selector/quarter-selector.component';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'miq-period-range',
  template: `
    <miq-filter-bar-label [props]="props()"></miq-filter-bar-label>
    <miq-quarter-selector
      [value]="value()"
      [type]="type()"
      [showAsQtd]="true"
      [maxValue]="maxValue()"
      [marketQtdVal]="marketQtdValue"
      (valueChange)="changeRange($event)"
    ></miq-quarter-selector>
  `,
  styleUrl: './period-range.component.scss',
  imports: [FilterBarLabelComponent, QuarterSelectorComponent],
})
export class PeriodRangeComponent implements OnInit, OnDestroy {
  value = input<QuarterRangeSelectorValue>();
  props = input<InputProps>();
  type = input<QuarterSelectorType>();
  selection = output<any>()
  marketQtd = input<number>();
  maxValue = input<QuarterSelectorValue | Date>();
  reportId = input<number>();
  reportType = input<string>();
  private readonly sharedApiService = inject(SharedApiService);

  private readonly cdr = inject(ChangeDetectorRef);
  public today = new Date();
  public marketQtdValue: Date | QuarterSelectorValue = this.today;
  constructor() {
    effect(() => {
      const marketQtd = this.marketQtd();
      const reportType = this.reportType();
      if (marketQtd && reportType === CorporateReportTypes.Corporate) {
        this.sharedApiService.getMarketQtd(marketQtd, this.reportId()).subscribe(
          qtdValue => {
            this.marketQtdValue =
              qtdValue == 0 ? this.today : { periodYear: this.today.getFullYear(), periodValue: qtdValue };
          },
          () => {
            this.marketQtdValue = this.today;
            this.cdr.markForCheck();
          }
        );
      }
    });
  }
  ngOnInit() {
    // required by language
  }
  ngOnDestroy() {
    // required by language
  }
  changeRange($event) {
    this.selection.emit({ [this.props().field]: $event });
  }
}
